var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewPosts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.575 22H7.425C4.4 22 3.025 21.2667 1.87917 20.1667C0.733333 18.975 0 17.6 0 14.575V7.425C0 4.4 0.733333 3.025 1.83333 1.87917C3.025 0.733333 4.4 0 7.425 0H14.575C17.6 0 18.975 0.733333 20.1208 1.83333C21.2667 3.025 22 4.4 22 7.425V14.575C22 17.6 21.2667 18.975 20.1667 20.1208C18.975 21.2667 17.6 22 14.575 22ZM7.425 1.375C4.58333 1.375 3.575 2.10833 2.79583 2.84167C2.10833 3.575 1.375 4.58333 1.375 7.425V14.575C1.375 17.4167 2.10833 18.425 2.84167 19.2042C3.575 19.9375 4.58333 20.625 7.425 20.625H14.575C17.4167 20.625 18.425 19.8917 19.2042 19.1583C19.9375 18.425 20.625 17.4167 20.625 14.575V7.425C20.625 4.58333 19.8917 3.575 19.1583 2.79583C18.425 2.10833 17.4167 1.375 14.575 1.375H7.425Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6375 11.6875H5.36255C4.99588 11.6875 4.67505 11.3667 4.67505 11C4.67505 10.6333 4.99588 10.3125 5.36255 10.3125H16.6375C17.0042 10.3125 17.325 10.6333 17.325 11C17.325 11.3667 17.0042 11.6875 16.6375 11.6875Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.325C10.6333 17.325 10.3125 17.0042 10.3125 16.6375V5.36249C10.3125 4.99582 10.6333 4.67499 11 4.67499C11.3667 4.67499 11.6875 4.99582 11.6875 5.36249V16.6375C11.6875 17.0042 11.3667 17.325 11 17.325Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPosts);
export default __webpack_public_path__ + "static/media/NewPosts.c2c26f8c4888b383bc44359eef17d09a.svg";
export { ForwardRef as ReactComponent };